import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetCatalogSubstitutionLotQueryVariables = Types.Exact<{
  productionLotId: Types.Scalars['String']['input'];
}>;


export type GetCatalogSubstitutionLotQuery = { __typename?: 'Query', productionLot?: { __typename?: 'ProductionLotStateData', productionLotId: string, lotNumber: number, quantity: number, finishJob: { __typename?: 'ProductionJobData', weekReadyDate: Types.TDateISO, productionJobId: string, productionCatalogId: string, productionCategoryId: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string }> }> }> } } | null };

export type ProductionLotSubstitutionPreviewQueryVariables = Types.Exact<{
  input: Types.ProductionLotSubstitutionPreviewInput;
}>;


export type ProductionLotSubstitutionPreviewQuery = { __typename?: 'Query', productionLotSubstitutionPreview: { __typename?: 'ProductionLotSubstitutionPayload', lots: Array<{ __typename?: 'ProductionLotSubstitutionLot', productionLotId: string, scope: Types.ProductionLotSubstitutionScope, substituted: boolean, hasPlannerOverrides: boolean, isLotSiteVariation: boolean, productionItemIdBefore?: string | null, productionItemIdAfter?: string | null, errors: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }>, missingRecipes: Array<{ __typename?: 'ProductionLotSubstitutionMissingRecipe', productionCategoryId: string, productionCategoryName: string, sourceProductionRecipeId: string }>, blockingAllocations: Array<{ __typename?: 'ProductionLotSubstitutionAllocation', allocationId: string, orderId: string, orderLineId?: string | null }>, jobs: Array<{ __typename?: 'ProductionLotSubstitutionJob', productionJobId: string, productionCategoryId: string, previousProductionRecipeId: string, newProductionRecipeId?: string | null, weekReadyDate: Types.TDateISO, weekStartDateBefore: Types.TDateISO, weekStartDateAfter?: Types.TDateISO | null, quantityToProduceAfter?: number | null }> }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CatalogSubstitutionJobFragment = { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string };

export type ProductionLotSubstitutionLotDataFragment = { __typename?: 'ProductionLotSubstitutionLot', productionLotId: string, scope: Types.ProductionLotSubstitutionScope, substituted: boolean, hasPlannerOverrides: boolean, isLotSiteVariation: boolean, productionItemIdBefore?: string | null, productionItemIdAfter?: string | null, errors: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }>, missingRecipes: Array<{ __typename?: 'ProductionLotSubstitutionMissingRecipe', productionCategoryId: string, productionCategoryName: string, sourceProductionRecipeId: string }>, blockingAllocations: Array<{ __typename?: 'ProductionLotSubstitutionAllocation', allocationId: string, orderId: string, orderLineId?: string | null }>, jobs: Array<{ __typename?: 'ProductionLotSubstitutionJob', productionJobId: string, productionCategoryId: string, previousProductionRecipeId: string, newProductionRecipeId?: string | null, weekReadyDate: Types.TDateISO, weekStartDateBefore: Types.TDateISO, weekStartDateAfter?: Types.TDateISO | null, quantityToProduceAfter?: number | null }> };

export const CatalogSubstitutionJobFragmentDoc = new TypedDocumentString(`
    fragment CatalogSubstitutionJob on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
}
    `, {"fragmentName":"CatalogSubstitutionJob"});
export const ProductionLotSubstitutionLotDataFragmentDoc = new TypedDocumentString(`
    fragment ProductionLotSubstitutionLotData on ProductionLotSubstitutionLot {
  productionLotId
  scope
  substituted
  errors {
    code
    message
  }
  missingRecipes {
    productionCategoryId
    productionCategoryName
    sourceProductionRecipeId
  }
  blockingAllocations {
    allocationId
    orderId
    orderLineId
  }
  hasPlannerOverrides
  isLotSiteVariation
  productionItemIdBefore
  productionItemIdAfter
  jobs {
    productionJobId
    productionCategoryId
    previousProductionRecipeId
    newProductionRecipeId
    weekReadyDate
    weekStartDateBefore
    weekStartDateAfter
    quantityToProduceAfter
  }
}
    `, {"fragmentName":"ProductionLotSubstitutionLotData"});
export const GetCatalogSubstitutionLotDocument = new TypedDocumentString(`
    query GetCatalogSubstitutionLot($productionLotId: String!) {
  productionLot(productionLotId: $productionLotId) {
    productionLotId
    lotNumber
    quantity
    finishJob {
      ...CatalogSubstitutionJob
      weekReadyDate
      childJobs {
        ...CatalogSubstitutionJob
        childJobs {
          ...CatalogSubstitutionJob
          childJobs {
            ...CatalogSubstitutionJob
          }
        }
      }
    }
  }
}
    fragment CatalogSubstitutionJob on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
}`);
export const ProductionLotSubstitutionPreviewDocument = new TypedDocumentString(`
    query ProductionLotSubstitutionPreview($input: ProductionLotSubstitutionPreviewInput!) {
  productionLotSubstitutionPreview(input: $input) {
    lots {
      ...ProductionLotSubstitutionLotData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotSubstitutionLotData on ProductionLotSubstitutionLot {
  productionLotId
  scope
  substituted
  errors {
    code
    message
  }
  missingRecipes {
    productionCategoryId
    productionCategoryName
    sourceProductionRecipeId
  }
  blockingAllocations {
    allocationId
    orderId
    orderLineId
  }
  hasPlannerOverrides
  isLotSiteVariation
  productionItemIdBefore
  productionItemIdAfter
  jobs {
    productionJobId
    productionCategoryId
    previousProductionRecipeId
    newProductionRecipeId
    weekReadyDate
    weekStartDateBefore
    weekStartDateAfter
    quantityToProduceAfter
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCatalogSubstitutionLot: build.query<GetCatalogSubstitutionLotQuery, GetCatalogSubstitutionLotQueryVariables>({
      query: (variables) => ({ document: GetCatalogSubstitutionLotDocument, variables })
    }),
    ProductionLotSubstitutionPreview: build.query<ProductionLotSubstitutionPreviewQuery, ProductionLotSubstitutionPreviewQueryVariables>({
      query: (variables) => ({ document: ProductionLotSubstitutionPreviewDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCatalogSubstitutionLotQuery, useLazyGetCatalogSubstitutionLotQuery, useProductionLotSubstitutionPreviewQuery, useLazyProductionLotSubstitutionPreviewQuery } = injectedRtkApi;
